import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {DrugIngredientDTO} from './DrugIngredientDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class NationalDrugDTO extends BaseDTO {
  nationalDrugId: number;
  masterDrug: NameValueDTO;
  referenceName: string;
  regulator: NameValueDTO;
  brandName: string;
  dosageForm: NameValueDTO;
  manufacturer: NameValueDTO;
  packPrice: number;
  currency: NameValueDTO;
  status: NameValueDTO;
  approvalReference: string;
  approvalDate: Date;
  startDate: Date;
  endDate: Date;
  nationalDrugCode: string;
  registrationOwner: string;
  drugName: string;
  eachPrice: number;
  country: string;

  routesOfAdmin: NameValueDTO[];
  ingredients: DrugIngredientDTO[];

  // FE usage
  ingredientsFirstTooltip?: string;
  ingredientsFullToolTip?: string;
  nationalDrugFormularyStartDate?: Date;
  nationalDrugFormularyEndDate?: Date;
}
